import { httpClient } from '../httpClient';

export const settingsApi = {
  getRoles: () =>
    httpClient.get('/settings/roles'),

  getRoleById: (id) =>
    httpClient.get(`/settings/roles/${id}`),

  createRole: (data) =>
    httpClient.post('/settings/roles', data),

  updateRole: (id, data) =>
    httpClient.put(`/settings/roles/${id}`, data),

  deleteRole: (id) =>
    httpClient.delete(`/settings/roles/${id}`),

  getPermissions: () =>
    httpClient.get('/settings/permissions'),

  getSystem: () =>
    httpClient.get('/settings/system'),

  updateSystem: (data) =>
    httpClient.put('/settings/system', data),

  getPdplCategories: () =>
    httpClient.get('/settings/pdpl-categories'),

  getDsrTypes: () =>
    httpClient.get('/settings/dsr-types'),

  getDatabaseCredentials: () =>
    httpClient.get('/settings/database-credentials'),

  createDatabaseCredential: (data) =>
    httpClient.post('/settings/database-credentials', data),

  updateDatabaseCredential: (id, data) =>
    httpClient.put(`/settings/database-credentials/${id}`, data),

  deleteDatabaseCredential: (id) =>
    httpClient.delete(`/settings/database-credentials/${id}`),
};
